export default {
  fontSize: {
    type: Number,
    default: 14,
  },
  field: {
    type: String,
    default: '',
  },
  value: {
    type: [String, Number],
    default: '',
  },
  openSelectedArr: {
    type: Boolean,
    default: false,
  },
  onOkAndContinue: {
    type: Boolean,
    default: false,
  },
  isReadOnly: {
    type: Boolean,
    default: false,
  },
  noAdd: {
    type: Boolean,
    default: false,
  },
  showOfSearchInput: {
    type: Boolean,
    default: true,
  },
  // 侧滑宽度
  sideModalWidth: {
    type: Number,
    default: 556,
  },
  // 侧滑或者弹出窗名称
  modelTitle: {
    type: String,
    default: '添加商品',
  },
  deploy: {
    type: Array,
    default: () => {
      return [
        {
          selectedArr: [], //已选的数据
          selectedArrKey: 'id', //已选数据中唯一值key
          sideAddKey: 'id', //侧滑表格中和已选表格中比较是否是同一值的key
          placeholder: '商品编码/商品名称', //搜索框提示值
          modelTableDataUrl: '', //获取数据的url
          tableRequestParam: {}, //获取数据的额外参数
          tableRequestMethod: 'get', //获取数据的请求方式
          addTableUrl: '', //将侧滑数据添加到外面的请求接口
          addrequestData: {}, //将侧滑数据添加到外面的请求参数
          addKey: '', //将侧滑数据添加到外面的请求参数中需要带上选中数据的某个值的数组的key
          requestype: 'post', //将侧滑数据添加到外面的请求方式
          modelTableDefUrl: '', //侧滑表格列定义请求接口
          tagTitle: '', //tag显示的值
          needCompareParam: null,
          dispatchComponent: null,
        },
      ]
    },
  },
}
